import React, { useEffect } from 'react';
import styled from '@emotion/styled';

const Ticker = styled.div({
    color: 'red',
});

export type AlertTickerProps = {
    caption: string;
    messages: string[];
}

export function AlertTicker(props: AlertTickerProps) {
    const { caption, messages } = props;

    useEffect(() => {
        console.warn(...messages);
    }, [messages]);

    return <Ticker>{caption}</Ticker>;
}
